import React, { Component } from 'react'
import { Switch, Redirect } from 'react-router-dom'
import PublicRoute from './PublicRoutes'
import RestrictedRoute from './RestrictedRoute'
import LoginPage from '../components/Login/LoginPage'
import ResetPassword from '../components/Login/ResetPassword'
import NewDistributorInductionForm from '../components/Distributors/NewDistributorInductionForm'
import ListofDistributors from '../components/Distributors/DistributorsList/ListofDistributors'
import IncompleteDistributors from '../components/Distributors/DistributorsList/IncompleteDistributors'
import vizLinkJobsList from '../components/VizlinkShops/JobsList/JobsList'
import VizLinkShopsList from '../components/VizlinkShops/VizShopsList/VizShopsList'
import vizLinkShopsOnBoardingDetails from '../components/VizlinkShops/OnBoardingShops/OnBoardingShops'
import ManageDailyOrders from '../components/DailyOrders/ManageDailyOrders/ManageDailyOrders'
import ManageOrderDetails from '../components/DailyOrders/ManageDailyOrders/ManageOrderDetails/ManageOrderDetails'
import OrderStatusReport from '../components/DailyOrders/OrderStatusReport'
import PaymentStatusReport from '../components/DailyOrders/PaymentStatusReport/PaymentStatusReport'
import OrderShopDetails from '../components/DailyOrders/PaymentStatusReport/OrderShopDetails/OrderShopDetails'
import ManageRSO from '../components/RSOs/ManageRSOs'
import ManageMFIs from '../components/MFIs/ManageMFIs'
import ManagePrincipals from '../components/Principals/ManagePrincipals'
import About from '../components/About/About'
import Dashboard from '../components/Dashboard/Dashboard'
import JobDetails from '../components/VizlinkShops/JobsList/JobDetails/JobDetails'
import RsoJobDetails from '../components/VizlinkShops/OnBoardingShops/RsoJobDetails/RsoJobDetails'
import ManageUsers from '../components/Users/ManageUsers'
import UserDataCorrection from '../components/Users/UserDataCorrection'
import UserBlockList from '../components/Users/UserBlockList'
import OnBoardingAgentsList from '../components/VizlinkAgents/OnBoardingAgentsList/OnBoardingAgentsList'
import RegisteredAgentsList from '../components/VizlinkAgents/RegisteredAgentsList/RegisteredAgentsList'
import CityAndArea from '../components/Settings/CityAndArea/CityAndArea'
import MfiWalletRequiredLimit from '../components/Settings/MfiWalletRequiredLimit/MfiWalletRequiredLimit'
import BusinessEntityType from '../components/Settings/BusinessEntityType/BusinessEntityType'
import Banks from '../components/Settings/Banks/Banks'
import Permissions from '../components/Settings/Permissions/Permissions'
import DailyTransactionsSummary from '../components/Reports/DailyTransactionsSummary/DailyTransactionsSummary'
import UsersStatus from '../components/Reports/UsersStatus/UsersStatus'
import ShopwiseTransactionsDetails from '../components/Reports/ShopwiseTransactionsDetails/ShopwiseTransactionsDetails'
import DigitalCollectionsReport from '../components/Reports/DigitalCollectionsReport/DigitalCollectionsReport'
import RsoDetailsReport from '../components/Reports/RsoDetailsReport/RsoDetailsReport'
import RsoPerformanceReport from '../components/Reports/RsoPerformanceReport/RsoPerformanceReport'
import QrTillList from '../components/QrTillDetails/QrTillList/QrTillList'
import DeliverymanUserRegistration from '../components/QrTillDetails/DeliverymanUserRegistration/DeliverymanUserRegistration'
import TillAssignmentForm from '../components/QrTillDetails/TillAssignmentForm/TillAssignmentForm'
import Versions from '../components/Settings/Versions/Versions'
import UserActivity from '../components/Settings/UserActivity/UserActivity'
import Sectors from '../components/VizlinkShops/Sectors/Sectors'
import Notifications from '../components/Settings/Notifications/Notifications'
import DailyCollectionsReport from '../components/QrTillDetails/DailyCollectionsReport/DailyCollectionsReport'
import SchemesList from '../components/VlLoyaltyProgram/SchemesList/SchemesList'
import CoinsHistoryReport from '../components/VlLoyaltyProgram/CoinsHistoryReport/CoinsHistoryReport'
import ShopWisePulseReport from '../components/Reports/AppPulse/ShopWisePulseReport/ShopWisePulseReport'
import DateWiseShopsSummaryReport from '../components/Reports/AppPulse/DateWiseShopsSummaryReport/DateWiseShopsSummaryReport'
import TillNumberDetails from '../components/QrTillDetails/TillNumberDetails/TillNumberDetails'
import DistributorConisDisbursmentReport from '../components/VlLoyaltyProgram/DistributorConisDisbursmentReport/DistributorConisDisbursmentReport'
import DeliveryManCoinsPaymentReport from '../components/VlLoyaltyProgram/DeliveryManCoinsPaymentReport/DeliveryManCoinsPaymentReport'
import DistributorCoinsPaymentReport from '../components/VlLoyaltyProgram/DistributorCoinsPaymentReport/DistributorCoinsPaymentReport'
import LoanDisbursementReport from '../components/LoanPayments/LoanDisbursementReport/LoanDisbursementReport'
import FinjaLoanReport from '../components/Reports/FinjaLoanReport/FinjaLoanReport'
import VLCCommunicationListing from '../components/VLConnect/VLCShopkeeperTickets/VLCCommunicationListing'
import DistributorInbox from '../components/VLConnect/DistributorInbox/DistributorInbox'
import ConnectConversation from '../components/VLConnect/ConnectConversation/ConnectConversation'
import DLMCollectionReport from '../components/DailyOrders/DLMCollectionReport/DLMCollectionReport'
import EditShop from '../components/VizlinkShops/EditShop/EditShop'
import InvoiceAllocationListing from '../components/DailyOrders/InvoiceAllocationListing/InvoiceAllocationListing'
import KycFormList from '../components/KYC/KycFormList/KycFormList'
import KycVisitRequiredList from '../components/KYC/KycVisitRequiredList/KycVisitRequiredList'
import KycInformationInquiryList from '../components/KYC/KycInformationInquiryList/KycInformationInquiryList'
import KYCFinalized from '../components/KYC/KYCFinalized/KYCFinalized'
import InvoiceWiseDailyCollectionDetails from '../components/M2DReorts/InvoiceWiseDailyCollectionDetails/InvoiceWiseDailyCollectionDetails'
import InvoiceWisePaymentBreakup from '../components/M2DReorts/InvoiceWisePaymentBreakup/InvoiceWisePaymentBreakup'
import Advertisements from '../components/Advertisements/Advertisements'
import SectorBasedReport from '../components/VizlinkShops/SectorBasedReport/SectorBasedReport'
import NotificationsScheduler from '../components/VizlinkShops/NotificationScheduler/NotificationScheduler'
import monthWiseM2DReport from '../components/M2DReorts/monthWiseM2DReport/monthWiseM2DReport'
import ShopsDetailReport from '../components/Reports/ShopsDetailReport/ShopsDetailReport'
import DisputedTransactionsReport from '../components/Reports/DisputedTransactionsReport/DisputedTransactionsReport'
// import SCRDetailReport from '../components/DailyOrders/SCRDetailReport/SCRDetailReport'
// import SCRSummaryReport from '../components/DailyOrders/SCRDetailReport/SCRSummaryReport/SCRSummaryReport'
// import SCRCompleteDetailReport from '../components/DailyOrders/SCRDetailReport/SCRCompleteDetailReport/SCRCompleteDetailReport'
import SCRV2DetailReport from '../components/DailyOrders/SCRV2DetailReport/SCRV2DetailReport'
import SCRV2CompleteDetailReport from '../components/DailyOrders/SCRV2DetailReport/SCRV2CompleteDetailReport'
import SCRV2SummaryReport from '../components/DailyOrders/SCRV2DetailReport/SCRV2SummaryReport'
import SCRV2TransactionReversal from '../components/DailyOrders/SCRV2TransactionReversal/SCRV2TransactionReversal'
import DeliverymanTrackingReport from '../components/DeliverymanReports/DeliverymanTrackingReport/DeliverymanTrackingReport'
import KycApprovalListForMuawin from '../components/KYC/KycApprovalListForMuawin/KycApprovalListForMuawin'
import InvoiceAllocationListingDetail from '../components/DailyOrders/InvoiceAllocationListing/InvoiceAllocationListingDetail'
// import InvoiceReopeningListing from '../components/DailyOrders/InvoiceReopeningListing/InvoiceReopeningListing'
// import InvoiceReopeningListingDetail from '../components/DailyOrders/InvoiceReopeningListing/InvoiceReopeningListingDetail'
import SCRReport from '../components/DailyOrders/SCRReport/SCRReport'
import DlmUniqueShopsDetailReport from '../components/DeliverymanReports/UniqueShopsDetailReport/DlmUniqueShopsDetailReport'
import DeliverymanUniqueShopsReport from '../components/DeliverymanReports/DeliverymanUniqueShopsReport/DeliverymanUniqueShopsReport'
import VizShopsRequestListing from '../components/VizlinkShops/VizShopsRequestList/VizShopsRequestListing'
import ExportReport from '../components/Reports/Export Report/ExportReport'
import LoanKycReport from '../components/LendingReports/LoanKycReport/LoanKycReport'
import LoanRepaymentReport from '../components/LendingReports/LoanRepaymentReport/LoanRepaymentReport'
import LoanVlpLedger from '../components/VlLoyaltyProgram/LoanVlpLedger/LoanVlpLedger'
import KYCListingForm from '../components/Financing/KYCListingForm/KYCListingForm'
import DisbursementFormList from '../components/Financing/DisbursementFormList/DisbursementFormList'
import DisbursementRejectionReport from '../components/LendingReports/DisbursementRejectionReport/DisbursementRejectionReport'
import GenerateCoinListing from '../components/VlLoyaltyProgram/GenerateCoinListing/GenerateCoinListing'
import AppGlobalSetting from '../components/Settings/GlobalSetting/AppGlobalSetting'
import FinancingLedgerReport from '../components/LendingReports/FinancingLedgerReport/FinancingLedgerReport'
import VFOVisitList from '../components/VFOVisitList/VFOVisitList'
import VFODailyVistSummaries from '../components/VFOVisitList/VFODailyVistSummaries/VFODailyVistSummaries'
import VfoTrackReport from '../components/VfoModule/VfoTrackReport/VfoTrackReport'
import CBDataSharingForm from '../components/KYC/CBDataSharing/CBDataSharingForm'
import ProfileSetting from '../components/Settings/UserMenu/ProfileSetting/ProfileSetting'
import ChangePassword from '../components/Settings/UserMenu/ChangePassword/ChangePassword'
import TransactionReopeningListing from '../components/DailyOrders/TransactionReopeningListing/TransactionReopeningListing'
import BaflKycReport from '../components/LendingReports/BaflKycReport/BaflKycReport'
import OneBillPaymentReport from '../components/M2DReorts/OneBillPaymentReport/OneBillPaymentReport'
import OneBillManualSettlement from '../components/OneBillManualSettlement/OneBillManualSettlement'
import DLMWiseBankDepositReport from '../components/DailyOrders/DLMWiseBankDepositReport/DLMWiseBankDepositReport'
import BankWiseDepositReport from '../components/DailyOrders/BankWiseDepositReport/BankWiseDepositReport'
import ShopKeeperInformationList from '../components/WhiteListing/ShopKeeperInformation/ShopKeeperInformationList'
import ShopTransactionalData from '../components/WhiteListing/ShopTransactionalData/ShopTransactionalData'
import MBLDistributorOnboardingList from '../components/MBLDistributorOnboarding/MBLDistributorOnboardingList'
import DistributorOnboardingForm from '../components/MBLDistributorOnboarding/DistributorOnboardingForm'
import CustomerDataReport from '../components/WhiteListing/ShopTransactionalData/CustomerDataReport/CustomerDataReport'
import monthWiseM2DDetailReport from '../components/M2DReorts/monthWiseM2DDetailReport/monthWiseM2DDetailReport'
import VfoPerformanceReport from '../components/Reports/VfoPerformanceReport/VfoPerformanceReport'
import VLConnectDetailReport from "../components/VLConnect/VLConnectDetailReport/VLConnectDetailReport"
import VLConnectActivityReport from '../components/VLConnect/VLConnectActivityReport/VLConnectActivityReport' 
import VLConnectSummaryReport from '../components/VLConnect/VLConnectSummaryReport/VLConnectSummaryReport'

class Routes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: false,
      clientCookie: false,
      logout: false,
    };
  }

  render() {
    return (
      <Switch>
        <Redirect strict exact from="/" to="/dashboard" />
        <PublicRoute
          restricted={true}
          component={LoginPage}
          path="/login"
          exact
        />
        <RestrictedRoute component={Dashboard} path="/dashboard" exact />
        <RestrictedRoute
          component={NewDistributorInductionForm}
          path="/AddDistributorInductionForm"
          exact
        />
        <RestrictedRoute
          component={ListofDistributors}
          path="/Distributors"
          exact
        />
        <RestrictedRoute
          component={IncompleteDistributors}
          path="/IncompleteDistributors"
          exact
        />
        <RestrictedRoute
          component={vizLinkJobsList}
          path="/vizLinkJobsList"
          exact
        />
        <RestrictedRoute
          component={VizLinkShopsList}
          path="/VizLinkShopsList"
          exact
        />

        <RestrictedRoute
          component={VizShopsRequestListing}
          path="/VizShopsRequestListing"
          exact
        />

        <RestrictedRoute
          component={vizLinkShopsOnBoardingDetails}
          path="/vizLinkShopsOnBoardingDetails"
          exact
        />
        <RestrictedRoute
          component={NotificationsScheduler}
          path="/NotificationsScheduler"
          exact
        />
        <RestrictedRoute component={Sectors} path="/sectors" exact />
        <RestrictedRoute
          component={SectorBasedReport}
          path="/SectorBasedReport"
          exact
        />
        <RestrictedRoute
          component={OnBoardingAgentsList}
          path="/VizAgentsList"
          exact
        />
        <RestrictedRoute
          component={RegisteredAgentsList}
          path="/RegisteredAgentsList"
          exact
        />
        <RestrictedRoute
          component={ManageDailyOrders}
          path="/NewOrdersForm"
          exact
        />
        <RestrictedRoute
          component={ManageOrderDetails}
          path="/ManageOrderDetails/:deliveryDate/:distCenterId"
          exact
        />
        <RestrictedRoute
          component={OrderStatusReport}
          path="/OrderStatusReport"
          exact
        />
        <RestrictedRoute
          component={PaymentStatusReport}
          path="/PaymentStatusReport"
          exact
        />
        <RestrictedRoute
          component={OrderShopDetails}
          path="/OrderShopDetails/:deliveryDate/:distCenterId"
          exact
        />
        <RestrictedRoute component={ManageRSO} path="/ManageRSO" exact />
        <RestrictedRoute component={ManageMFIs} path="/ManageMFIs" exact />
        <RestrictedRoute
          component={ManagePrincipals}
          path="/ManagePrincipals"
          exact
        />
        <RestrictedRoute component={About} path="/About" exact />
        <RestrictedRoute
          component={NewDistributorInductionForm}
          path="/EditDistributorInductionForm/:id"
          exact
        />
        <RestrictedRoute component={JobDetails} path="/JobDetails/:id" exact />
        <RestrictedRoute
          component={RsoJobDetails}
          path="/RsoJobDetails/:id/:rsoId"
          exact
        />
        <RestrictedRoute component={ManageUsers} path="/ManageUsers" exact />
        <RestrictedRoute
          component={UserBlockList}
          path="/UserBlockList"
          exact
        />
        <RestrictedRoute component={ManageUsers} path='/ManageUsers' exact />
        <RestrictedRoute
          component={UserDataCorrection}
          path='/UserDataCorrection'
          exact
        />
        <RestrictedRoute component={UserBlockList} path='/UserBlockList' exact />
        <RestrictedRoute component={CityAndArea} path='/CityAndArea' exact />
        <RestrictedRoute
          component={MfiWalletRequiredLimit}
          path="/MfiWalletRequiredLimit"
          exact
        />
        <RestrictedRoute
          component={BusinessEntityType}
          path="/BusinessEntityType"
          exact
        />
        <RestrictedRoute component={Banks} path="/Banks" exact />
        <RestrictedRoute component={Permissions} path="/Permissions" exact />
        <RestrictedRoute component={Versions} path="/Versions" exact />
        <RestrictedRoute component={UserActivity} path="/UserActivity" exact />
        <RestrictedRoute
          component={Notifications}
          path="/Notifications"
          exact
        />
        <RestrictedRoute
          component={DailyTransactionsSummary}
          path="/DailyTransactionsSummary"
          exact
        />
        <RestrictedRoute
          component={UsersStatus}
          path="/UserDetailsReport"
          exact
        />
        <RestrictedRoute
          component={ShopwiseTransactionsDetails}
          path="/ShopwiseTransactionsDetails"
          exact
        />
        <RestrictedRoute
          component={DigitalCollectionsReport}
          path="/DigitalCollectionsReport"
          exact
        />
        <RestrictedRoute
          component={RsoDetailsReport}
          path="/RsoDetailsReport"
          exact
        />
        <RestrictedRoute
          component={RsoPerformanceReport}
          path="/RsoPerformanceReport"
          exact
        />
        <RestrictedRoute
          component={ShopWisePulseReport}
          path="/ShopWisePulseReport"
          exact
        />
        <RestrictedRoute
          component={DateWiseShopsSummaryReport}
          path="/DateWiseShopsSummaryReport"
          exact
        />
        <RestrictedRoute component={QrTillList} path="/QrTillList" exact />
        <RestrictedRoute
          component={DeliverymanUserRegistration}
          path="/DeliverymanUserRegistration"
          exact
        />
        <RestrictedRoute
          component={TillAssignmentForm}
          path="/TillAssignmentForm"
          exact
        />
        <RestrictedRoute
          component={DailyCollectionsReport}
          path="/DailyCollectionsReport"
          exact
        />
        <RestrictedRoute
          component={DLMWiseBankDepositReport}
          path="/DLMWiseBankDepositReport"
          exact
        />
        <RestrictedRoute
          component={BankWiseDepositReport}
          path="/BankWiseDepositReport"
          exact
        />
        <RestrictedRoute
          component={CoinsHistoryReport}
          path="/CoinsHistoryReport"
          exact
        />
        <RestrictedRoute
          component={DistributorConisDisbursmentReport}
          path="/DistributorCoinsDisbursmentReport"
          exact
        />
        <RestrictedRoute
          component={DeliveryManCoinsPaymentReport}
          path="/DeliveryManCoinsPaymentReport"
          exact
        />
        <RestrictedRoute
          component={VfoPerformanceReport}
          path="/VfoPerformanceReport"
          exact
        />
        <RestrictedRoute component={SchemesList} path="/SchemesList" exact />
        <RestrictedRoute
          component={TillNumberDetails}
          path="/TillNumberDetails"
          exact
        />
        <RestrictedRoute
          component={DistributorCoinsPaymentReport}
          path="/DistributorCoinsPaymentReport"
          exact
        />
        <RestrictedRoute
          component={LoanDisbursementReport}
          path="/LoanDisbursementReport"
          exact
        />
        <RestrictedRoute
          component={FinjaLoanReport}
          path="/FinjaLoanReport"
          exact
        />
        <RestrictedRoute
          component={VLCCommunicationListing}
          path="/VLCCommunicationListing"
          exact
        />
        <RestrictedRoute
          component={ConnectConversation}
          path="/ConnectConversation"
          exact
        />

        <RestrictedRoute
          component={DistributorInbox}
          path="/DistributorInbox"
          exact
        />

        <RestrictedRoute
          component={DLMCollectionReport}
          path="/DLMCollectionReport"
          exact
        />
        <RestrictedRoute
          component={DLMWiseBankDepositReport}
          path="/DLMWiseBankDepositReport"
          exact
        />

        <RestrictedRoute
          component={EditShop}
          path="/EditShop/:id/:request/:readOnly"
          exact
        />
        <RestrictedRoute
          component={InvoiceAllocationListing}
          path="/InvoiceAllocationListing"
          exact
        />

        <RestrictedRoute
          component={InvoiceAllocationListingDetail}
          path="/InvoiceAllocationListingDetail"
          exact
        />

        <RestrictedRoute
          component={ShopKeeperInformationList}
          path="/ShopKeeperInformationList"
          exact
        />
        <RestrictedRoute
          component={ShopTransactionalData}
          path="/ShopTransactionalData"
          exact
        />
        <RestrictedRoute
          path="/CustomerDataReport/:id"
          component={CustomerDataReport}
        />

        <RestrictedRoute component={KycFormList} path="/KycFormList" exact />
        <RestrictedRoute
          component={KycVisitRequiredList}
          path="/KycVisitRequiredList"
          exact
        />
        <RestrictedRoute
          component={KycInformationInquiryList}
          path="/KycInformationInquiryList"
          exact
        />
        <RestrictedRoute component={KYCFinalized} path="/KYCFinalized" exact />
        <RestrictedRoute
          component={InvoiceWiseDailyCollectionDetails}
          path="/InvoiceWiseDailyCollectionDetails"
          exact
        />
        <RestrictedRoute
          component={InvoiceWisePaymentBreakup}
          path="/InvoiceWisePaymentBreakup"
          exact
        />
        <RestrictedRoute
          component={monthWiseM2DReport}
          path="/monthWiseM2DReport"
          exact
        />

        <RestrictedRoute
          component={monthWiseM2DDetailReport}
          path="/monthWiseM2DDetailReport"
          exact
        />

        <RestrictedRoute
          component={OneBillPaymentReport}
          path="/1BillPaymentReport"
          exact
        />
        <RestrictedRoute
          component={OneBillManualSettlement}
          path="/OneBillManualSettlement"
          exact
        />

        <RestrictedRoute
          component={VLConnectDetailReport}
          path="/VLConnectDetailReport"
          exact
        />

        <RestrictedRoute
          component={VLConnectActivityReport}
          path="/VLConnectActivityReport"
          exact
        />
        <RestrictedRoute
          component={VLConnectSummaryReport}
          path="/VLConnectSummaryReport"
          exact
        />

        <RestrictedRoute
          component={Advertisements}
          path="/Advertisements"
          exact
        />
        <RestrictedRoute
          component={ShopsDetailReport}
          path="/ShopsDetailReport"
          exact
        />
        <RestrictedRoute
          component={DisputedTransactionsReport}
          path="/DisputedTransactionsReport"
          exact
        />
        <RestrictedRoute
          component={SCRV2DetailReport}
          path="/SCRV2DetailReport"
          exact
        />
        <RestrictedRoute
          component={SCRV2CompleteDetailReport}
          path="/SCRV2CompleteDetailReport/:scrId"
          exact
        />
        <RestrictedRoute
          component={SCRV2SummaryReport}
          path="/SCRV2SummaryReport/:scrId"
          exact
        />
        <RestrictedRoute
          component={KycApprovalListForMuawin}
          path="/KycApprovalListForMuawin"
          exact
        />
        <RestrictedRoute
          component={TransactionReopeningListing}
          path="/TransactionReopeningListing"
          exact
        />
        <RestrictedRoute
          component={SCRV2TransactionReversal}
          path="/SCRV2TransactionReversal"
          exact
        />
        {/* <RestrictedRoute
          component={InvoiceReopeningListing}
          path='/InvoiceReopeningListing'
          exact
        />
        <RestrictedRoute
          component={InvoiceReopeningListingDetail}
          path='/InvoiceReopeningListingDetail'
          exact
        /> */}
        <RestrictedRoute component={SCRReport} path="/SCRReport" exact />
        <RestrictedRoute
          component={DeliverymanUniqueShopsReport}
          path="/DeliverymanUniqueShopsReport"
          exact
        />

        <RestrictedRoute
          component={DlmUniqueShopsDetailReport}
          path="/DlmUniqueShopsDetailReport"
          exact
        />
        <RestrictedRoute component={ExportReport} path="/ExportReport" exact />

        <RestrictedRoute
          component={LoanKycReport}
          path="/LoanKycReport"
          exact
        />
        <RestrictedRoute
          component={BaflKycReport}
          path="/BaflKycReport"
          exact
        />
        <RestrictedRoute
          component={LoanRepaymentReport}
          path="/LoanRepaymentReport"
          exact
        />

        <RestrictedRoute
          component={LoanVlpLedger}
          path="/LoanVlpLedger"
          exact
        />
        <RestrictedRoute
          component={KYCListingForm}
          path="/KYCListingForm"
          exact
        />

        <RestrictedRoute
          component={MBLDistributorOnboardingList}
          path="/MBLDistributorOnboardingList"
          exact
        />
        <RestrictedRoute
          path="/mbl-distributor-onboarding/add"
          component={DistributorOnboardingForm}
        />
        <RestrictedRoute
          path="/mbl-distributor-onboarding/edit/:id"
          component={DistributorOnboardingForm}
        />
        <RestrictedRoute
          path="/mbl-distributor-onboarding/view/:id"
          component={DistributorOnboardingForm}
        />

        <RestrictedRoute
          component={DisbursementFormList}
          path="/DisbursementFormList"
          exact
        />
        <RestrictedRoute component={VFOVisitList} path="/VFOVisitList" exact />
        <RestrictedRoute
          component={VFODailyVistSummaries}
          path="/VFODailyVistSummaries/:vfoId/:visitDate"
          exact
        />

        <RestrictedRoute
          component={DisbursementRejectionReport}
          path="/DisbursementRejectionReport"
          exact
        />

        <RestrictedRoute
          component={FinancingLedgerReport}
          path="/FinancingLedgerReport"
          exact
        />

        <RestrictedRoute
          component={AppGlobalSetting}
          path="/AppGlobalSetting"
          exact
        />

        <RestrictedRoute
          component={VfoTrackReport}
          path="/VfoTrackReport"
          exact
        />

        <RestrictedRoute
          component={DeliverymanTrackingReport}
          path="/DeliverymanTrackingReport"
          exact
        />

        <RestrictedRoute
          component={CBDataSharingForm}
          path="/CBDataSharingForm"
          exact
        />

        <RestrictedRoute
          component={ProfileSetting}
          path="/ProfileSetting"
          exact
        />

        <RestrictedRoute
          component={ChangePassword}
          path="/ChangePassword"
          exact
        />
        <RestrictedRoute
          component={GenerateCoinListing}
          path="/GenerateCoinListing"
          exact
        />

        <PublicRoute path="*">
          <Redirect to="/" />
        </PublicRoute>
      </Switch>
    );
  }
}

export default Routes
